import { round, roundCurrency } from 'utils';

import { TendersByCurrency } from './OCDTypes';

export const spreadTenders = (dict: TendersByCurrency[string]) => {
  const newDict: Record<string, number | string> = {};
  Object.keys(dict).forEach(key => {
    const { reason, counted } = dict[key];
    const trailingDash = /-$/;
    // CARD- is the expected way to send the CARD payment info if it was paid with integration 'none'
    const newKey = key === 'CARD-' ? key : key.replace(trailingDash, '');
    newDict[`varianceReasonID-${newKey}`] = reason !== -1 ? reason : '';
    newDict[`counted-${newKey}`] = Number(counted) || 0;
  });
  return newDict;
};

export const getDifference = (expected: number, counted: string) =>
  // counted is rounded using roundCurrency thus to avoid issues with difference
  // use the same rounding algorithm for expected
  Math.abs(Number(counted) - roundCurrency(expected));

export const isWithinAllowedDifference = (
  expected: number,
  counted: string,
  allowedDifference: number,
) => {
  const difference = getDifference(expected, counted);
  // round to avoid binary floating point math issues
  return Number(round(difference)) <= allowedDifference;
};

export const asFloat = (value: string | null | undefined) =>
  value ? Number(value) || 0 : 0;
